import React, { useState } from 'react';
import EcoImg from 'eco-design/base/eco-img';
import styles from './index.module.scss';

interface ImagesListProps {
    images: {
        pc: string;
        pad: string;
        h5: string;
        thumbnailUrl: string;
        h5ThumbnailUrl: string;
        alt?: string;
        desc?: string;
        title?: string;
    }[];
    desc?: string;
    title?: string;
    onChange?: (index: number) => void;
}
const ImagesList: React.FC<ImagesListProps> = ({ images, desc, title, onChange }) => {
    const [activeIndex, setActiveIndex] = useState(0);

    const handleClick = (index: number) => {
        setActiveIndex(index);
        onChange && onChange(index);
    };

    return (
        <section className={styles.ImagesList}>
            <EcoImg className="main-img" pc={images[activeIndex]?.pc} pad={images[activeIndex]?.pad} h5={images[activeIndex]?.h5}></EcoImg>
            <div className="desc-box">
                <div className="left-desc">
                    <p className="title1">{title || images[activeIndex].title}</p>
                    <div className="desc">{desc || images[activeIndex].desc}</div>
                </div>
                <div className="thumbnail-list">
                    {images.map((item, index) => (
                        <div key={index} className={`${activeIndex === index ? 'active' : ''} thumbnail-item`} onClick={() => handleClick(index)}>
                            <EcoImg className="sub-img" alt={item.alt} pc={item.thumbnailUrl} pad={item.thumbnailUrl} h5={item.h5ThumbnailUrl}></EcoImg>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ImagesList;
